module.exports = __webpack_public_path__ + "static/heroOlympo36-811a16e3b57e1c2d3bee4641e02f4897.png";